export default __webpack_public_path__ + "static/obshchepit-presentation-653d2a351a2e17c4c7c6e8346cfa50de.png";